import axios from 'axios';
import { initializePaddle } from '@paddle/paddle-js';

const isRetainPage = window.location.href.indexOf('/retain') !== -1;

const initUrl = '/rest/paddle/info/client-options';

export const paddleRetainHandlers = async () => {
    if (!isRetainPage) {
        return;
    }

    try {
        const initResponse = await axios.post(initUrl);
        const paddleInitOptions = {
            environment: initResponse.data.environment,
            token: initResponse.data.publicKey,
        };

        if (initResponse.data.customerId) {
            paddleInitOptions.customerId = initResponse.data.customerId;
        }

        await initializePaddle(paddleInitOptions);
    } catch (error) {
        console.log(error);
    }
};
